module.exports = __webpack_public_path__ + "static/img/manager_firma_kurt.6c5eae5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manager_firma_kurt.png
// module id = rDO9
// module chunks = 1